export const paginatorTheme = {
  colorScheme: {
    light: {
      root: {
        borderRadius: '0 0 0.5rem 0.5rem',
        background: 'var(--surface-fill)'
      },
      navButton: {}
    },
    dark: {
      root: {
        borderRadius: '0 0 0.5rem 0.5rem',
        background: 'var(--surface-fill)'
      },
      navButton: {}
    }
  }
};
